import { atom } from 'recoil'
import { decodeToken, getTokenExpiration } from '../lib/token'
import { axios } from '../lib/request'

/**
 * Create custom sign in state to be used as AuthProvider key.
 * With the key, provider re-renders when user is authenticated and
 * triggers an updated interval for the useRefreshApi hook.
 */
export const signInState = atom({
    key: 'sign-in-key',
    default: null,
})

export const expirationFromNow = token => {
    const exp = decodeToken(token)?.expiration
    const milliseconds = 1000
    const minToSeconds = 60
    return (exp * milliseconds - Date.now()) / (milliseconds * minToSeconds)
}

export const buildSignInToken = (data, user_id) => {
    try {
        const { lifespan, refresh_token, token } = data
        const tokenType = "Bearer"
        const authState = {
            user_id,
            user_type: "email",
            refresh_token,
            token,
            lifespan,
        }

        return {
            authState,
            token,
            tokenType,
            expiresIn: lifespan,
            refreshToken: refresh_token,
            refreshTokenExpireIn: expirationFromNow(refresh_token),
        }
    } catch {
        return {}
    }
}

export const refreshToken = async (
    {
        authToken,
        refreshToken,
        isRefresh,
        currentAuthState = null,
    }) => {
    try {
        const response = await axios.post(process.env.REACT_APP_API_REFRESH_URL,
            { 'refresh_token': refreshToken },
            {
                headers: {
                    'Authorization': `Bearer ${authToken}`
                }
            }
        )
        if (response?.data) {
            return isRefresh
                ? {
                    isSuccess: true,
                    newAuthUserState: { ...currentAuthState, token: response.data.token },
                    newAuthToken: response.data.token,
                    newAuthTokenExpireIn: getTokenExpiration(response.data)?.interval,
                    newRefreshToken: response.data.refresh_token,
                    newRefreshTokenExpiresIn: getTokenExpiration(response.data)?.interval,
                }
                : buildSignInToken(response?.data, currentAuthState?.user_id)
        }
        return {
            isSuccess: false,
        }
    } catch (e) {
        return {
            isSuccess: false,
        }
    } finally {
        document.dispatchEvent(new Event("tokenRefresh"))
    }
}